import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentModel } from 'src/app/models/document.model';
import { BuilderRequest } from 'src/app/models/requests';
import { LoggingService } from 'src/app/services/logging.service';
import { ModalOpenerService } from 'src/app/modals/modal-opener.service';

@Component({
  selector: 'app-reviewandsenddocumentslist',
  templateUrl: './reviewandsenddocumentslist.component.html'
})
export class ReviewandsenddocumentslistComponent implements OnInit {

  @Input('request') request!: BuilderRequest;
  @Output('openPDFViewer') openPDFViewer = new EventEmitter();

  docValue: string = "Xbrl only";
  isMobile: boolean = false;

  constructor(private modalService: NgbModal,
    private modalOpenerService: ModalOpenerService,
    private loggingService: LoggingService) {
  }


  ngOnInit(): void {
    if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i) !== null) this.isMobile = true;
  }

  async openPreview(event: any) {
    if (event.document?.filetype === ".PDF") {
      this.openPdfPreview(event.document).catch((error) => this.loggingService.logException(error));
    } else if (event.document?.filetype === ".XBRL") {
      this.modalOpenerService.Open_ViewXblrOrTxt(this.request, event.document);
    } else if (event.document.filetype.toLocaleLowerCase() == ".xml") {
      this.modalOpenerService.Open_ViewXml(this.request.id!, event.document);
    }
  }

  async openPdfPreview(document: DocumentModel) {
    this.openPDFViewer.emit({ documentId: document.id, actor: document.actors, actors: document.actors, place: false, displayfields: true });
  }
}
